import { Injectable } from '@angular/core';
import { SessionService } from '@bayclubs/utils';
import { security } from '../models/security';
import { WindowRef } from "../providers/window.provider";

@Injectable()
export class AppSessionService {

    constructor(private window: WindowRef, private session: SessionService) {
        console.log('creating session service');

    }

    set campsPriviliges(priviliges: security.CampsSecurityContext) {
        this.session.setItem('campsPriviliges', priviliges);
    }

    get campsPriviliges(): security.CampsSecurityContext {
        return this.session.getItem<security.CampsSecurityContext>('campsPriviliges', null);
    }

    public dispose() {
        this.window.nativeWindow.sessionStorage.clear();
    }
}
